import styled from 'styled-components';

// === Card Shell ===
export const Card = styled.article`
  border-radius: 1rem;
  background-color: rgb(255 255 255);
  border: 1px solid rgb(226 232 240);
  overflow: hidden;
  box-shadow: 0 22px 48px rgba(15, 23, 42, 0.10);
`;

// === Header ===
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: ${props => props.$haserror === 'true' 
    ? 'linear-gradient(to right, rgb(185 28 28), rgb(220 38 38), rgb(239 68 68))'
    : 'linear-gradient(to right, rgb(4 120 87), rgb(5 150 105), rgb(16 185 129))'
  };

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.75rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const Avatar = styled.div`
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 9999px;
  background-color: rgba(16 185 129 / 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarText = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: rgb(255 255 255);
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: rgb(255 255 255);
  margin: 0;
`;

export const Age = styled.span`
  color: rgb(209 250 229);
  font-size: 13px;
`;

export const RenewalBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  margin-left: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 4px;
  vertical-align: middle;
`;

export const DOB = styled.p`
  font-size: 14px;
  color: rgba(209 250 229 / 0.8);
  margin: 0;
`;

export const MetadataWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 768px) {
    justify-content: flex-end;
    text-align: right;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  border-radius: 9999px;
  background-color: rgba(16 185 129 / 0.1);
  border: 1px solid rgba(209 250 229 / 0.4);
  padding: 0.25rem 0.625rem;
  font-size: 11px;
  font-weight: 500;
  color: rgb(236 253 245);
`;

export const BadgeDot = styled.span`
  height: 0.375rem;
  width: 0.375rem;
  border-radius: 9999px;
  background-color: ${props => props.$eligibilityGuardTriggered === 'true' ? 'rgb(239 68 68)' : 'rgb(167 243 208)'};
`;

export const UpdateInfo = styled.span`
  font-size: 13px;
  color: rgba(236 253 245 / 0.8);
  white-space: nowrap;
`;

export const Location = styled.span`
  font-weight: 600;
  color: rgb(255 255 255);
`;

// === Body ===
export const Body = styled.div`
  padding: 1.25rem 1.25rem;

  @media (min-width: 768px) {
    padding: 1.25rem 1.5rem;
  }
`;

export const BodyInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

// === PRIMARY: Clinical Eligibility ===
export const CEVPrimary = styled.section`
  border-radius: 0.75rem;
  border: 1px solid ${props => props.$haserror === 'true' ? 'rgb(254 226 226)' : 'rgb(209 250 229)'};
  background-color: ${props => props.$haserror === 'true' ? 'rgb(254 242 242)' : 'rgb(236 253 245)'};
  padding: 1rem;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.12);
`;

export const CEVHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const CEVTitle = styled.p`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: ${props => props.$haserror === 'true' ? 'rgb(153 27 27)' : 'rgb(4 120 87)'};
  margin: 0;
`;

export const CEVStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  background-color: ${props => props.$haserror === 'true' ? 'rgb(220 38 38)' : 'rgb(5 150 105)'};
  padding: 0.125rem 0.625rem;
  font-size: 12px;
  font-weight: 600;
  color: rgb(255 255 255);
`;

export const CEVFlags = styled.div`
  margin-top: 0.75rem;
  margin-bottom: 0.9375rem;
  border-radius: 0.5rem;
  background-color: rgb(255 255 255);
  border: 1px solid ${props => props.$haserror === 'true' ? 'rgb(254 226 226)' : 'rgb(209 250 229)'};
  padding: 0.625rem 0.75rem;
  font-size: 13px;
`;

export const CEVFlagsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

export const CEVFlagsLabel = styled.span`
  font-weight: 500;
  color: rgb(30 41 59);
`;

export const CEVToggle = styled.button`
  font-size: 11px;
  font-weight: 500;
  color: ${props => props.$haserror === 'true' ? 'rgb(153 27 27)' : 'rgb(4 120 87)'};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export const CEVFlagsContent = styled.div`
  height: ${props => props.$expanded ? '300px' : '70px'};
  overflow-y: auto;
  transition: height 200ms ease-out;
`;

export const CEVFlagsText = styled.p`
  color: rgb(71 85 105);
  margin: 0;
  font-size: 18px;
  line-height: 1.5;
`;

export const CEVFlaggedQuestions = styled.div`
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
`;

export const FlaggedQuestionItem = styled.div`
  border-radius: 0.375rem;
  background-color: rgb(254 242 242);
  border: 1px solid rgb(254 202 202);
  padding: 0.625rem 0.75rem;
`;

export const FlaggedQuestionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.375rem;
`;

export const FlaggedQuestionIcon = styled.div`
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  background-color: rgb(239 68 68);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.125rem;
  
  svg {
    width: 0.625rem;
    height: 0.625rem;
    color: white;
  }
`;

export const FlaggedQuestionText = styled.div`
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  color: rgb(30 41 59);
  line-height: 1.4;
`;

export const FlaggedQuestionAnswer = styled.div`
  font-size: 12px;
  color: rgb(71 85 105);
  margin-left: 1.5rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
  
  strong {
    font-weight: 600;
    color: rgb(51 65 85);
  }
`;

export const FlaggedQuestionReason = styled.div`
  font-size: 12px;
  color: rgb(127 29 29);
  margin-left: 1.5rem;
  font-style: italic;
  line-height: 1.4;
`;

// === Supporting Medication Context ===
export const MedContextGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const MedContextCard = styled.div`
  border-radius: 0.5rem;
  border: 1px solid rgb(226 232 240);
  background-color: ${props => props.$haserror === 'true' ? 'rgb(254 242 242)' : 'rgb(248 250 252)'};
  padding: 0.75rem 1rem;
`;

export const MedContextLabel = styled.p`
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgb(100 116 139);
  margin: 0;
  opacity: 0.7;
`;

export const MedContextTitle = styled.p`
  margin-top: 0.25rem;
  font-size: 15px;
  font-weight: 500;
  color: rgb(30 41 59);
  margin-bottom: 0;
`;

export const MedContextSub = styled.p`
  font-size: 14px;
  color: rgb(71 85 105);
  margin: 0.125rem 0 0 0;
`;

export const MedContextNote = styled.p`
  margin-top: 0.25rem;
  font-size: 13px;
  color: rgb(100 116 139);
  margin-bottom: 0;
`;

// === Clinical Snapshot ===
export const SnapshotCard = styled.section`
  border-radius: 0.5rem;
  border: 1px solid rgb(241 245 249);
  background-color: rgb(255 255 255);
  padding: 0.625rem 0.75rem;
  margin-top: 0.9375rem;
`;

export const SnapshotTitle = styled.p`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgb(100 116 139);
  margin: 0 0 0.5rem 0;
`;

export const SnapshotGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem 1rem;
  font-size: 13px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const SnapshotItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SnapshotLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgb(100 116 139);
  white-space: nowrap;
`;

export const SnapshotValue = styled.span`
  font-weight: 500;
  color: rgb(30 41 59);
`;

// === Footer ===
export const Footer = styled.section`
  padding-top: 0.75rem;
  border-top: 1px solid rgb(241 245 249);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 0.75rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const FooterMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
`;

export const VerifiedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 9999px;
  background-color: rgb(236 253 245);
  border: 1px solid rgb(209 250 229);
  padding: 0.25rem 0.625rem;
  font-size: 12px;
  font-weight: 500;
  color: rgb(4 120 87);

  svg {
    height: 0.875rem;
    width: 0.875rem;
    color: rgb(16 185 129);
  }
`;

export const StatusText = styled.span`
  font-size: 12px;
  color: rgb(100 116 139);
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  @media (min-width: 640px) {
    flex-direction: row;
    width: auto;
  }
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 9999px;
  padding: 0.375rem 0.875rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: none;
  font-family: inherit;
  width: 100%;

  @media (min-width: 640px) {
    width: auto;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SecondaryButton = styled(Button)`
  border: 1px solid rgb(226 232 240);
  background-color: rgb(255 255 255);
  color: rgb(51 65 85);

  &:hover:not(:disabled) {
    background-color: rgb(248 250 252);
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: rgb(5 150 105);
  color: rgb(255 255 255);
  font-weight: 600;
  padding: 0.375rem 1rem;
  font-size: 15px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  &:hover:not(:disabled) {
    background-color: rgb(4 120 87);
  }

  &:disabled {
    background-color: rgb(156 163 175);
  }
`;

// Legacy exports for backward compatibility (if needed)
export const Actions = Footer;
export const Status = FooterMeta;
export const StatusItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;
export const StatusDot = styled.span`
  height: 0.375rem;
  width: 0.375rem;
  border-radius: 9999px;
  background-color: ${props => props.$eligibilityGuardTriggered === 'true' ? 'rgb(239 68 68)' : 'rgb(16 185 129)'};
`;
export const StatusSeparator = styled.span`
  color: rgb(203 213 225);
`;

// === Collapsed Success State ===
export const CollapsedSuccess = styled.div`
  border-radius: 1rem;
  background: linear-gradient(135deg, rgb(236 253 245) 0%, rgb(209 250 229) 100%);
  border: 1px solid rgb(167 243 208);
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
  transition: all 0.3s ease;
  
  /* Fade in animation with slight delay for better visual flow */
  animation: fadeInSlideUp 0.4s ease-out;
  
  @keyframes fadeInSlideUp {
    0% {
      opacity: 0;
      transform: translateY(12px) scale(0.98);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  &:hover {
    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.2);
  }

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
`;

export const SuccessLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
`;

export const SuccessIcon = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 9999px;
  background: linear-gradient(135deg, rgb(16 185 129), rgb(5 150 105));
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.4);
`;

export const SuccessInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  flex: 1;
`;

export const SuccessPatientName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: rgb(4 120 87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SuccessMessage = styled.div`
  font-size: 13px;
  color: rgb(5 150 105);
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-wrap: wrap;
`;

export const SuccessTimestamp = styled.span`
  font-size: 12px;
  color: rgb(16 185 129);
  font-weight: 500;
`;

export const SuccessPrescription = styled.div`
  font-size: 12px;
  color: rgb(16 185 129);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.125rem;
  
  svg {
    font-size: 11px;
    flex-shrink: 0;
    margin-bottom: 0.125rem;
  }
`;

export const SuccessMedication = styled.span`
  font-weight: 600;
  color: rgb(4 120 87);
`;

export const SuccessRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: 640px) {
    justify-content: stretch;
    width: 100%;
  }
`;

export const SuccessButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid rgb(167 243 208);
  background-color: rgb(255 255 255);
  color: rgb(4 120 87);
  font-family: inherit;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: rgb(236 253 245);
    border-color: rgb(16 185 129);
  }

  @media (max-width: 640px) {
    flex: 1;
  }
`;

export const DismissButton = styled.button`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 9999px;
  border: none;
  background-color: rgba(255, 255, 255, 0.6);
  color: rgb(5 150 105);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 12px;
  flex-shrink: 0;

  &:hover {
    background-color: rgb(255 255 255);
    color: rgb(4 120 87);
  }

  @media (max-width: 640px) {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
  }
`;

export const CircularProgress = styled.div`
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;
`;

export const CircularProgressSvg = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

export const CircularProgressBackground = styled.circle`
  fill: none;
  stroke: rgba(255, 255, 255, 0.3);
  stroke-width: 3;
`;

export const CircularProgressForeground = styled.circle`
  fill: none;
  stroke: rgb(5 150 105);
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
  stroke-dasharray: ${props => {
    const radius = 18;
    const circumference = 2 * Math.PI * radius;
    return circumference;
  }};
  stroke-dashoffset: ${props => {
    const radius = 18;
    const circumference = 2 * Math.PI * radius;
    const progress = props.$progress || 0;
    return circumference - (progress / 100) * circumference;
  }};
`;

export const CircularProgressIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgb(5 150 105);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FeedbackSection = styled.div`
  padding: 1rem 1.25rem;
  border-top: 1px solid rgb(254 226 226);
  background-color: rgb(254 242 242);
`;

export const FeedbackLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgb(127 29 29);
  margin-bottom: 0.5rem;
`;

export const FeedbackTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 0.625rem 0.75rem;
  border: 1px solid rgb(252 165 165);
  border-radius: 0.5rem;
  font-size: 14px;
  font-family: inherit;
  color: rgb(51 65 85);
  background-color: rgb(255 255 255);
  resize: vertical;
  transition: all 0.15s ease;

  &:focus {
    outline: none;
    border-color: rgb(239 68 68);
    box-shadow: 0 0 0 3px rgba(239 68 68 / 0.1);
  }

  &::placeholder {
    color: rgb(148 163 184);
  }
`;

export const OverridePrescribeButton = styled.button`
  margin-top: 0.75rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(to right, rgb(239 68 68), rgb(220 38 38));
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: linear-gradient(to right, rgb(220 38 38), rgb(185 28 28));
    box-shadow: 0 4px 12px rgba(220 38 38 / 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 16px;
  }
`;

export const ErrorMessage = styled.div`
  width: 100%;
  padding: 12px 20px;
  background-color: #f8d7da;
  border-top: 1px solid #f5c2c7;
  color: #842029;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: auto;
  
  .anticon {
    color: #dc3545;
    font-size: 16px;
    flex: 0 0 auto;
  }
  
  span {
    flex: 1 1 auto;
  }
`;

export const ErrorDismissButton = styled.button`
  padding: 6px 16px;
  background-color: #dc3545;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  pointer-events: auto;
  position: relative;
  z-index: 10;
  
  &:hover {
    background-color: #bb2d3b;
  }
  
  &:active {
    background-color: #a02532;
  }
`;
